<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.select_delivery_time') }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="">
            <v-list class="list-delivery_time_v2 pt-0">
              <template v-for="(item, idx) in delivery_time">
                <v-list-item :key="idx" :disabled="disabled[idx]" class="min-height-auto py-2 px-0" @click="goTo(item.ftime)">
                  <div :class="['list-image-avatar', { 'avatar_delivery_time_disabled': disabled[idx] }]">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 0C15.514 0 20 4.486 20 10C20 15.514 15.514 20 10 20C4.486 20 0 15.514 0 10C0 4.486 4.486 0 10 0ZM10 2C5.589 2 2 5.589 2 10C2 14.411 5.589 18 10 18C14.411 18 18 14.411 18 10C18 5.589 14.411 2 10 2ZM11 5V9.58594L13.707 12.293L12.293 13.707L9 10.4141V5H11Z" fill="#272727" />
                    </svg>
                    <!-- <img src="@/assets/images/v2/img/icon_time.png" :alt="$t('v2.restaurant_courier')" class="image-20"> -->
                  </div>
                  <v-list-item-content>
                    <v-list-item-title :class="['line-height-normal font-14 font-weight-600', { 'ol-grey-content' : disabled[idx] }]">
                      {{ item.ftime }}
                      <template v-if="$store.state.selected_store.delivery.unlimited_items_order === 0">
                        <span v-if="item.order_left < 6" class="font-14 font-weight-600">
                          ( {{ $t('v2.order_left_message', { order_left: item.order_left }) }} )
                        </span>
                      </template>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <div :key="idx + 'divider'" class="div-line" />
              </template>
            </v-list>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {
  delieverytimes as getDelieveryTimes
} from '@/api/setting'
export default {
  data() {
    return {
      disabled: [],
      delivery_time: [],
      shipping: {}
    }
  },
  mounted() {
    const LOCAL_DATA_SHIPPING = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_shipping')
    if (LOCAL_DATA_SHIPPING) {
      this.shipping = JSON.parse(LOCAL_DATA_SHIPPING)
    }
    this.getListTime()
  },
  methods: {
    goBack() {
      this.$router.push({ name: '_delivery_method' }).catch(() => {})
    },
    async getListTime() {
      const today = new Date()
      const curDay = today.getDay() + 1
      try {
        const { data } = await getDelieveryTimes(curDay)
        this.delivery_time = data.data.times
        for (var i = 0; i < this.delivery_time.length; i++) {
          if (this.$store.state.selected_store.delivery.unlimited_items_order === 0) {
            if (this.delivery_time[i].order_left === 0 || this.delivery_time[i].time_has_passed === 1) {
              this.disabled[i] = true
            } else {
              this.disabled[i] = false
            }
          } else {
            if (this.delivery_time[i].time_has_passed === 1) {
              this.disabled[i] = true
            } else {
              this.disabled[i] = false
            }
          }
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    goTo(time) {
      this.shipping.shipping_time = time
      this.$store.dispatch('saveShippingV2', this.shipping)
      this.$router.push({ name: '_checkout' }).catch(() => {})
    }
  }
}
</script>
